/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UsersStatisticsQueryVariables = {|
  userId: string
|};
export type UsersStatisticsQueryResponse = {|
  +usersStatistics: ?{|
    +user: ?{|
      +joinedAt: any
    |},
    +marketCurrentTotal: ?number,
    +profitLoss: ?number,
    +invested: ?number,
    +percentageDiff: ?number,
    +grantMoney: ?number,
  |}
|};
export type UsersStatisticsQuery = {|
  variables: UsersStatisticsQueryVariables,
  response: UsersStatisticsQueryResponse,
|};
*/


/*
query UsersStatisticsQuery(
  $userId: String!
) {
  usersStatistics(userId: $userId) {
    user {
      joinedAt
    }
    marketCurrentTotal
    profitLoss
    invested
    percentageDiff
    grantMoney
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "UsersStatistics",
    "kind": "LinkedField",
    "name": "usersStatistics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "joinedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketCurrentTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profitLoss",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invested",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentageDiff",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grantMoney",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersStatisticsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersStatisticsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9fb3b29baa72e48807697aaf1a6a4d41",
    "id": null,
    "metadata": {},
    "name": "UsersStatisticsQuery",
    "operationKind": "query",
    "text": "query UsersStatisticsQuery(\n  $userId: String!\n) {\n  usersStatistics(userId: $userId) {\n    user {\n      joinedAt\n    }\n    marketCurrentTotal\n    profitLoss\n    invested\n    percentageDiff\n    grantMoney\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f6e18b04a71bdb4718cb69e40a613e2d';

module.exports = node;
